import { AdaptedComponents } from '../../../types/AdaptedComponents';
import { TextField } from './TextField';
import { Dropdown } from './Dropdown';
import { PaymentMethodsList } from './PaymentMethodsList';
import { PaymentMethodScreen } from './PaymentMethodScreen';
import { Checkbox } from './Checkbox';
import { TextButton } from './TextButton';

export const AdaptedComponentsTPA: AdaptedComponents = {
  TextField,
  Dropdown,
  PaymentMethodsList,
  PaymentMethodScreen,
  Checkbox,
  TextButton,
};
